module.exports = __webpack_public_path__ + "img/horizontal_4_1_pp1_6.e2efb1fb.png";